import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
interface MenuItem {
  title: string;
  url: string;
  children?: {
    title: string;
    url: string;
  }[];
}
const menuItems: MenuItem[] = [{
  title: 'Home',
  url: '/'
}, {
  title: 'Services',
  url: '/services',
  children: [{
    title: 'Mobile App Development',
    url: '/services/mobile-apps'
  }, {
    title: 'Custom Web Development',
    url: '/services/web-development'
  }, {
    title: 'Embedded Systems',
    url: '/services/embedded-systems'
  }, {
    title: 'Database Solutions',
    url: '/services/database-solutions'
  }, {
    title: 'High Availability',
    url: '/services/high-availability'
  }, {
    title: 'Global File System',
    url: '/services/global-file-system'
  }]
}, {
  title: 'AI & Automation',
  url: '/ai-automation'
}, {
  title: 'Project Support',
  url: '/support'
}, {
  title: 'About',
  url: '/about'
}, {
  title: 'Contact',
  url: '/contact'
}];
export function DesktopMenu() {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const location = useLocation();
  function isActive(path: string): boolean {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  }
  return <nav className="hidden md:flex items-center gap-8" data-id="element-79">
      {menuItems.map(item => {
      if (item.children && item.children.length > 0) {
        return <div key={item.title} className="relative" onMouseEnter={() => setOpenDropdown(item.title)} onMouseLeave={() => setOpenDropdown(null)} data-id="element-80">
              <a href={item.url} className={`flex items-center gap-1 text-base font-medium transition-colors duration-200 ${isActive(item.url) ? 'text-white' : 'text-blue-200 hover:text-white'}`} data-id="element-81">
                {item.title}
                <motion.span animate={{
              rotate: openDropdown === item.title ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="inline-flex" data-id="element-82">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-83">
                    <polyline points="6 9 12 15 18 9" data-id="element-84" />
                  </svg>
                </motion.span>
              </a>

              <AnimatePresence data-id="element-85">
                {openDropdown === item.title && <motion.div initial={{
              opacity: 0,
              y: -8
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -8
            }} transition={{
              duration: 0.15
            }} className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 bg-white rounded-lg shadow-xl border border-border overflow-hidden" data-id="element-86">
                    <div className="py-2" data-id="element-87">
                      {item.children.map(child => <a key={child.url} href={child.url} className="flex items-center gap-3 px-4 py-2.5 text-sm text-ink hover:bg-background hover:text-accent transition-colors" data-id="element-88">
                          {child.title}
                        </a>)}
                      {item.url && <div className="border-t border-neutral mt-1 pt-1" data-id="element-89">
                          <a href={item.url} className="flex items-center gap-3 px-4 py-2.5 text-sm font-semibold text-accent hover:bg-background transition-colors" data-id="element-90">
                            View All {item.title} →
                          </a>
                        </div>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      }
      return <a key={item.title} href={item.url} className={`text-base font-medium transition-colors duration-200 ${isActive(item.url) ? 'text-white' : 'text-blue-200 hover:text-white'}`} data-id="element-91">
            {item.title}
          </a>;
    })}
    </nav>;
}